module.exports = __webpack_public_path__ + "static/media/  (161).810b591c.jpg";